<template>
  <div class="searchComapny-theme">
    <Header></Header>
    <div class="addcreat_root">
      <div class="addcreat">
        <h1 class="addcreat-h1">{{ $t("AddCredit.Customizeyourplan") }}</h1>

        <div class="flex_between_box">
          <div class="addcreat-card">
            <div>
              <img src="../../assets/img/zhanshi0.png" alt="" />

              <h3 class="arrcreat-head">{{ $t("AddCredit.Silver") }}</h3>
            </div>

            <div class="arrcreat-bottom">
              <span v-if="vipYing == 0" class="arrcreat-bottom-money"
                >$300</span
              >
              <span v-if="vipYing == 1" class="arrcreat-bottom-money"
                >${{ 3000 | FilterNum }}</span
              >
              <span class="arrcreat-bottomi">{{
                arrcreatfen == "month"
                  ? $t("AddCredit.Usermonth")
                  : $t("AddCredit.Useryear")
              }}</span>
              <!-- <span class="arrcreat-bottomi">user/ {{ arrcreatfen }}</span> -->
            </div>
            <p class="arrcreat-bottomp">
              ({{
                vipYing == 0
                  ? $t("AddCredit.PaidMonthlyRenews")
                  : $t("AddCredit.PaidAnnuallyRenews")
              }})
              <!-- ({{ vipYing == 0 ? "Paid monthly" : "Paid annually" }}, no need for
            auto renews) -->
            </p>
            <div class="vipqiehuan flex_center_bettwen">
              <button
                @click="
                  vipYing = 0;
                  arrcreatfen = 'month';
                "
                :class="
                  vipYing == 0
                    ? 'ipqiehuan_button ipqiehuan_buttonactive'
                    : 'ipqiehuan_button'
                "
              >
                {{ $t("AddCredit.PaidMonthly") }}
              </button>
              <button
                @click="
                  vipYing = 1;
                  arrcreatfen = 'year';
                "
                :class="
                  vipYing == 1
                    ? 'ipqiehuan_button ipqiehuan_buttonactive'
                    : 'ipqiehuan_button'
                "
              >
                {{ $t("AddCredit.PaidAnnually") }}
              </button>
            </div>
            <div></div>

            <div>
              <button
                :disabled="userinfo?.userInfo?.userType == 3"
                :class="
                  userinfo?.userInfo?.userType == 3
                    ? 'black_buttonhui'
                    : 'black_button'
                "
                @click="GetStarted(1)"
              >
                {{ $t("AddCredit.BuyNow") }}
              </button>
            </div>
            <ul class="arrcreat-countet">
              <p class="arrcreat-li-gouxuan">
                {{ $t("AddCredit.SearchCompanies") }}:
              </p>
              <div>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.UnlimitedAdvancedSearch")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.ViewCompanyProfile")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.CompanyOwnershipStructure")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.CompanyFamilyTree")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.Companymanagement")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.CompanyContactsinfo")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.BusinessActivities")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.IndustryBasics")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.ImportExportRecords")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.CompanyPublications")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.CompanyNews")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.DownloadOnlineReport")
                  }}</span>
                </li>
              </div>
            </ul>
          </div>
          <div class="addcreat-card">
            <div>
              <img src="../../assets/img/zhanshi2.png" alt="" />

              <h3 class="arrcreat-head">{{ $t("AddCredit.Gold") }}</h3>
            </div>

            <div class="arrcreat-bottom">
              <span
                v-if="vipJin == 0"
                class="arrcreat-bottom-money"
                style="color: #e58c1d"
                >${{ 1500 | FilterNum }}</span
              >
              <span
                v-if="vipJin == 1"
                class="arrcreat-bottom-money"
                style="color: #e58c1d"
                >${{ 8000 | FilterNum }}</span
              >
              <span v-if="vipJin == 0" class="arrcreat-bottomi">{{
                $t("AddCredit.Usermonth")
              }}</span>
              <span v-if="vipJin == 1" class="arrcreat-bottomi">{{
                $t("AddCredit.Useryear")
              }}</span>
            </div>
            <p class="arrcreat-bottomp">
              ({{
                vipYing == 0
                  ? $t("AddCredit.PaidMonthlyRenews")
                  : $t("AddCredit.PaidAnnuallyRenews")
              }})
            </p>
            <div class="vipqiehuan flex_center_bettwen">
              <button
                @click="vipJin = 0"
                :class="
                  vipJin == 0
                    ? 'ipqiehuan_button ipqiehuan_buttonactiveyellow'
                    : 'ipqiehuan_button'
                "
              >
                {{ $t("AddCredit.PaidMonthly") }}
              </button>
              <button
                @click="vipJin = 1"
                :class="
                  vipJin == 1
                    ? 'ipqiehuan_button ipqiehuan_buttonactiveyellow'
                    : 'ipqiehuan_button'
                "
              >
                {{ $t("AddCredit.PaidAnnually") }}
              </button>
            </div>
            <div></div>

            <div>
              <button
                :disabled="userinfo?.userInfo?.userType == 3"
                :class="
                  userinfo?.userInfo?.userType == 3
                    ? 'black_buttonhui'
                    : 'black_button'
                "
                @click="GetStarted(2)"
              >
                {{ $t("AddCredit.BuyNow") }}
              </button>
            </div>
            <ul class="arrcreat-countet">
              <p class="arrcreat-li-gouxuan">
                {{ $t("AddCredit.EverythinginSilverPackage") }}:
              </p>
              <div>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.ManagementDetails") }}</span
                  >
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.ShareholderPenetration") }}</span
                  >
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.Financialinfo") }}</span
                  >
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.FinancialAnalysis") }}</span
                  >
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.CreditAssessment") }}</span
                  >
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.IndustryAnalysis") }}</span
                  >
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.MarketAnalysis") }}</span
                  >
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.SupplyChaininfo") }}</span
                  >
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.CheckSanctions") }}</span
                  >
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.CompanyComparison") }}</span
                  >
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.DataExport") }}</span
                  >
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.MonitoringService") }}</span
                  >
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">
                    {{ $t("AddCredit.DiscountForFreshUpdateReports") }}</span
                  >
                </li>
              </div>
            </ul>
          </div>
          <div class="addcreat-card">
            <div>
              <img src="../../assets/img/zhuansi3.png" alt="" />

              <h3 class="arrcreat-head">
                <span>{{ $t("AddCredit.Enterpris") }}</span>
              </h3>
            </div>

            <div class="arrcreat-bottom">
              <p class="Contactus">{{ $t("AddCredit.Contactus") }}</p>
            </div>
            <p class="arrcreat-bottomp">
              ({{ $t("AddCredit.ForFullSupport") }})
            </p>
            <div
              class="vipqiehuan flex_center_bettwen"
              style="background: transparent"
            ></div>
            <div></div>

            <div>
              <a href="mailto:service@csibizinfo.com" style="color: #fff">
                <button class="black_button">
                  {{ $t("AddCredit.ContactNow") }}
                </button>
              </a>
            </div>
            <ul class="arrcreat-countet">
              <p class="arrcreat-li-gouxuan">
                {{ $t("AddCredit.EverythinginSilverPackage") }}:
              </p>
              <div>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.SearchCompany")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.SearchLeads")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.SearchTrade")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.SearchPeople")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.SearchCountry")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.SearchNews")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.SearchSanction")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.DataServices")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.APIPlans")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.VolumeDiscounts")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.GroupAccountsWithMultipleUsers")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.CustomizedPlans")
                  }}</span>
                </li>
              </div>
            </ul>
          </div>
          <div class="addcreat-card">
            <div>
              <img src="../../assets/img/zhanshi3.png" alt="" />

              <h3 class="arrcreat-head flex_center_bettwen" style="ju">
                <span>{{ $t("AddCredit.Credit") }}</span>
                <span class="Creditpoints">
                  <!-- {{ $t("AddCredit.Remaining") }} {{$store.state.app.equityType}}
                  {{ $t("AddCredit.Points") }} -->
                   {{ $t("AddCredit.Remaining",[$store.state.app.equityType]) }}
                  </span
                >
              </h3>
            </div>

            <div class="arrcreat-bottom">
              <span class="arrcreat-bottom-money" style="color: #1290c9"
                >${{ (Num * CreditNum) | FilterNum }}</span
              >
            </div>
            <div class="arrcreat-bottom-last">
              <el-input v-model="Num" autocomplete="off" @input="validateInput">
                <span slot="suffix" class="each"
                  >/ ${{ CreditNum }} {{ $t("AddCredit.Each") }}
                </span>
              </el-input>
            </div>
            <p class="arrcreat-bottomp">
              ({{ $t("AddCredit.CreditsCharged") }})
            </p>

            <div>
              <button
                :disabled="this.Num == 0"
                :class="this.Num == 0 ? 'black_buttonhui' : 'black_button'"
                @click="GetStarted(5)"
              >
                {{ $t("AddCredit.BuyNow") }}
              </button>
            </div>
            <ul class="arrcreat-countet">
              <p class="arrcreat-li-gouxuan">
                {{ $t("AddCredit.CreditsCanbeUsed") }}:
              </p>
              <div>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.FreshInvestigatedCreditReportsWorldwide")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.BusinessMonitoringServices")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.BusinessProcessVerificationServices")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.VendorComplianceReports")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.DataServices")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.MarketResearch")
                  }}</span>
                </li>
                <li class="arrcreat-li-gouxuan flex_box">
                  <i class="el-icon-check"></i
                  ><span style="padding-left: 10px">{{
                    $t("AddCredit.More")
                  }}</span>
                </li>
              </div>
            </ul>
          </div>
        </div>
      </div>
      <!-- 点击 Update data 后弹出 -->
      <el-dialog
        :visible.sync="purchaseDialog"
        center
        :close-on-click-modal="true"
        custom-class=" puy_dialog"
        :append-to-body="true"
      >
        <div class="detail_cont">
          <el-form
            ref="purchaseForm"
            :model="purchaseForm"
            :rules="purchaseRules"
            class="form_box"
            label-position="left"
          >
            <div class="purc_right">
              <h3 class="pay_title m_b_20">
                {{ $t("AddCredit.PaymentMethod") }}
              </h3>
              <el-form-item
                :label="$t('AddCredit.CreditCardNumber')"
                prop="cardNumber"
                class="inpt_line m_l_20"
              >
                <el-input
                  autocomplete="off"
                  v-model="purchaseForm.cardNumber"
                  :placeholder="$t('AddCredit.EnterCardNumber')"
                  maxlength="16"
                ></el-input>
              </el-form-item>

              <el-form-item
                :label="$t('AddCredit.ExpirationDate')"
                prop="expMonth"
                class="inpt_line m_l_20"
                style="margin-bottom: 0px"
              >
                <div class="flex_center_bettwen flex_input pay_expDate">
                  <el-form-item
                    label=""
                    prop="expMonth"
                    class="inpt_line"
                    style="width: 100%"
                  >
                    <el-select
                      v-model="purchaseForm.expMonth"
                      :placeholder="$t('AddCredit.Month')"
                      class="fin_top_sel"
                      autocomplete="off"
                    >
                      <el-option
                        :label="item.laber"
                        :value="item.value"
                        v-for="(item, index) in monthOptions"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label=""
                    prop="expYear"
                    class="inpt_line"
                    style="width: 100%"
                  >
                    <el-select
                      v-model="purchaseForm.expYear"
                      :placeholder="$t('AddCredit.Year')"
                      class="fin_top_sel"
                      autocomplete="off"
                    >
                      <el-option
                        :label="item"
                        :value="item"
                        v-for="(item, index) in yearOptions"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item
                :label="$t('AddCredit.Fullnameoncard')"
                prop="fullName"
                class="inpt_line"
              >
                <el-input
                  v-model="purchaseForm.fullName"
                  autocomplete="off"
                  :placeholder="$t('AddCredit.EnterFullname')"
                  maxlength="64"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('AddCredit.Country')"
                prop="country"
                class="inpt_line"
              >
                <el-select
                  v-model="purchaseForm.country"
                  filterable
                  :placeholder="$t('Home.selectCountry')"
                  class="fin_top_sel"
                  @change="changeCountry"
                  autocomplete="off"
                >
                  <el-option
                    v-for="item in countryOptions"
                    :key="item.countryCode"
                    :label="item.nameEn"
                    :value="item.countryCode"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                :label="$t('AddCredit.ProvinceState')"
                prop="province"
                class="inpt_line m_l_20"
              >
                <el-input
                  v-model="purchaseForm.province"
                  :placeholder="$t('AddCredit.EnterProvinceState')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('AddCredit.CVCCode')"
                prop="cardCode"
                class="inpt_line"
              >
                <el-input
                  autocomplete="off"
                  :placeholder="$t('AddCredit.EnterCVCCode')"
                  v-model="purchaseForm.cardCode"
                  maxlength="4"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="Postal Code" prop="zip" autocomplete="off" class="inpt_line m_l_20">
                            <el-input v-model="purchaseForm.zip"></el-input>
                        </el-form-item> -->

              <div class="total_txt m_b_20">
                <span class="title_tol" style="display: inline-block">
                  {{ $t("AddCredit.TotalPurchase") }}</span
                >
                <span class="SelectNumm"
                  ><span class="dollar_sign">$</span
                  >{{ SelectNumm | FilterNum }}</span
                >
              </div>
              <!-- <div class="pay_price m_b_20" v-if="!Subscriber">$ {{ purchaseForm?.price }}</div> -->
              <!-- <div v-if="Subscriber" class="pay_price m_b_20">
                                  $ {{ purchaseForm.price + productList[1]?.actualPrice }}
                                  <span>/year</span>
                              </div> -->

              <div class="tip_txt m_b_40">
                {{ $t("AddCredit.Agree1") }}
                <span
                  style="color: #1290c9; cursor: pointer"
                  @click="ReportError = true"
                >
                  {{ $t("AddCredit.Agree2") }}</span
                >
              </div>
              <div class="btn_box">
                <!--                 <el-button class="btn_cancel btn_box_item" @click="btnCancel">{{
                  $t("AddCredit.Cancel")
                }}</el-button> -->
                <el-button
                  class="btn_export btn_box_item"
                  style="background: #1290c9"
                  @click="onSubmit"
                  >{{ $t("AddCredit.Submit") }}</el-button
                >
              </div>
            </div>
          </el-form>
        </div>
      </el-dialog>
      <PermissionDialog></PermissionDialog>
      <DisclamerTranlation
        :showReport="ReportError"
        @closeReportDialog="closeDialog($event)"
      ></DisclamerTranlation>
    </div>
  </div>
</template>
<script>
import {
  cardAuthorize,
  getPublicClientKey,
  saveUserRecharges,
  getoptions,
} from "@/api/companyApi.js";
import Header from "@/views/newLayout/header.vue";
import { createScript } from "@/utils/acceptcreate";
import { getProductList, failedPay } from "@/api/api.js";
import gui_chart from "@/components/gui_chart/gui_chart.vue";
import PermissionDialog from "@/components/power/PermissionDialog.vue";
import DisclamerTranlation from "../../components/DisclaimerTranslation/index.vue";
export default {
  components: { Header, gui_chart, PermissionDialog, DisclamerTranlation },
  data() {
    return {
      ReportError: false,
      purchaseDialog: false,
      userinfo: JSON.parse(localStorage.getItem("userInfo")),
      isNew: true,
      SelectNumm: 0,
      Num: 0,
      NumAll: "",
      vipYing: 0,
      vipJin: 0,
      arrcreatfen: "month",
      CreditNum: 30,
      purchaseForm: {
        price: "",
        loginAccount: "",
        fullName: "",
        cardNumber: "",
        expMonth: "",
        expYear: "",
        cardCode: "",
        country: "",
        province: "",
        zip: "",
      },
      ProductList: [],
      yearOptions: [],
      monthOptions: [
        { laber: "1", value: "01" },
        { laber: "2", value: "02" },
        { laber: "3", value: "03" },
        { laber: "4", value: "04" },
        { laber: "5", value: "05" },
        { laber: "6", value: "06" },
        { laber: "7", value: "07" },
        { laber: "8", value: "08" },
        { laber: "9", value: "09" },
        { laber: "10", value: "10" },

        { laber: "11", value: "11" },

        { laber: "12", value: "12" },
      ],
      countryOptions: [],
      provinceOptions: [],
      apiLoginID: "",
      clientKey: "",
      orderId: "",
      proviceArrLoading: false,
      purchaseRules: {
        fullName: [
          {
            required: true,
            message: this.$t("AddCredit.IncorrectFullNameformat"),
            trigger: "blur",
          },
        ],
        cardNumber: [
          {
            required: true,
            message: this.$t("AddCredit.IncorrectCreditCardNumberformat"),
            trigger: "blur",
          },
        ],
        expMonth: [
          {
            required: true,
            message: this.$t("AddCredit.IncorrectExpMonthformat"),
            trigger: "change",
          },
        ],
        expYear: [
          {
            required: true,
            message: this.$t("AddCredit.IncorrectExpYearformat"),
            trigger: "change",
          },
        ],
        cardCode: [
          {
            required: true,
            message: this.$t("AddCredit.IncorrectCVCCodeformat"),
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: this.$t("AddCredit.IncorrectCountryformat"),
            trigger: "change",
          },
        ],
        province: [
          {
            required: true,
            message: this.$t("AddCredit.IncorrectProvinceStateformat"),
            trigger: "change",
          },
        ],
        zip: [
          {
            required: true,
            message: "Incorrect Postal Code format",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.getProductList();
  },
  mounted() {
    this.getYears();
    this.getCountry();
    // 引入外部js文件 acept.js 脚本已经加载，并且 Accept 对象可用 支付环境加载
    // const scriptElement = createScript('https://jstest.authorize.net/v1/Accept.js');// dev 环境
    const scriptElement = createScript("https://js.authorize.net/v1/Accept.js"); // prod 环境
    scriptElement.onload = function () {
      // 输出xxx.js中的xxx
    };
    this.$store.dispatch("app/setThemColor", "#1290C9");
    this.$store.dispatch("app/setSearchType", "company");
  },
  methods: {
    closeDialog(value) {
      this.ReportError = value;
    },
    validateInput() {
      // 获取输入的值
      const value = this.Num;

      // 使用正则表达式检查是否为整数
      if (!/^\d*$/.test(value)) {
        // 如果不是整数，清空输入框
        this.Num = "";
      }
    },
    GetStarted(item) {
      if (item == 5 && this.Num == 0) {
        this.purchaseDialog = false;
        return;
      } else {
        this.purchaseDialog = true;
      }
      let price = 0;
      let id = 0;
      if (item == 1) {
        if (this.vipYing == 0) {
          price = 300;
          id = 1;
        } else {
          price = 3000;
          id = 2;
        }
      }
      if (item == 2) {
        if (this.vipJin == 0) {
          price = 1500;
          id = 3;
        } else {
          price = 8000;
          id = 4;
        }
      }
      if (item == 5) {
        id = 5;
      }

      this.SelectNumm = item == 5 ? this.Num * this.CreditNum : price;
      this.getPCKey();
      this.getOrdersAddPro(id, price);
    },
    getOrdersAddPro(item, price) {
      saveUserRecharges({
        vipPointsPricingId: item,
        points: item == 5 ? this.Num : null,
        paymentAmount: item == 5 ? this.Num * this.CreditNum : price,
        actualAmount: item == 5 ? this.Num * this.CreditNum : price,
        paymentMethod: 1,
      }).then((res) => {
        if (res.code == 200) {
          this.orderId = res.data;
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      });
    },
    getProductList() {
      getProductList().then((res) => {
        if (res.code == 200) {
          this.ProductList = res.data;
          this.ProductList.forEach((item) => {
            if (item.id == 5) {
              this.CreditNum = item.price;
            }
          });
        } else {
          this.ProductList = [];
        }
      });
    },
    getPCKey() {
      getPublicClientKey().then((result) => {
        let data = result;
        if (data && data.code && data.data) {
          this.apiLoginID = data.data.apiLoginID;
          this.clientKey = data.data.clientKey;
        }
      });
    },
    getYears() {
      const loadYear = new Date().getFullYear() - 1;
      const n = 11;
      for (var i = 0; i < n; i++) {
        const year = loadYear + i;
        this.yearOptions.push(year.toString());
      }
      return this.yearOptions;
    },
    //获取国家
    getCountry() {
      this.countryOptions = JSON.parse(
        localStorage.getItem("countryList"),
      )[0].countryList;
    },
    changeCountry() {
      this.purchaseForm.province = "";
      this.provinceOptions = [];
      if (this.purchaseForm.country) {
        this.getProvince();
      }
    },
    //获取省市
    async getProvince() {
      this.proviceArrLoading = true;
      const params = {
        page: 1,
        pageSize: 10,
        company_country: this.purchaseForm.country,
      };
      this.provinceOptions = [];
    },
    //刷新菜单
    getKey(val) {
      if (val === 0) {
      }
    },
    onSubmit() {
      this.$refs.purchaseForm.validate(async (valid) => {
        if (valid) {
          let authData = {};
          authData.clientKey = this.clientKey;
          authData.apiLoginID = this.apiLoginID;

          let cardData = {};
          cardData.fullName = this.purchaseForm.fullName;
          cardData.cardNumber = this.purchaseForm.cardNumber;
          cardData.month = this.purchaseForm.expMonth;
          cardData.year = this.purchaseForm.expYear;
          cardData.cardCode = this.purchaseForm.cardCode;

          var secureData = {};
          secureData.authData = authData;
          secureData.cardData = cardData;

          let lastResponse = null;
          const responseHandler = (response) => {
            try {
              if (response == lastResponse) {
                return;
              }
              lastResponse = response;
              if (response.messages.resultCode === "Error") {
                for (let i = 0; i < response.messages.message.length; i++) {
                  this.$message({
                    message:
                      response.messages.message[i].code +
                      ": " +
                      response.messages.message[i].text,
                    type: "error",
                    duration: 3000,
                  });
                }
              } else {
                this.postCardAuthorize(response.opaqueData);
              }
            } catch (error) {}
          };
          window.Accept.dispatchData(secureData, responseHandler);
        } else {
          return false;
        }
      });
    },
    postCardAuthorize(opaqueData) {
      let params = {
        dataValue: opaqueData.dataValue, //必须
        dataDescriptor: opaqueData.dataDescriptor, //必须
        orderId: this.orderId, //必须
      };
      cardAuthorize(params).then((result) => {
        let that = this;
        if (result.code == 200) {
          this.purchaseDialog = false;
          this.$message({
            message: result.msg,
            center: true,
            type: "success",
          });
          setTimeout(function () {
            that.$router.go(0);
          }, 1000); // 20
        } else {
          this.purchaseDialog = false;
          this.$message({
            message: result.msg,
            center: true,
            type: "error",
          });
          setTimeout(function () {
            that.$router.go(0);
          }, 1000);
        }
      });
    },
    //取消
    btnCancel() {
      failedPay({
        id: this.orderId,
        status: 4,
      }).then((res) => {});
      this.purchaseDialog = false;
      this.purchaseForm.price = "";
      this.clientKey = "";
      this.apiLoginID = "";
      this.clientKey = "";
      this.orderId = "";
    },
  },
};
</script>
<style scoped>
.right_box {
  width: 100% !important;
}

.cont_m {
  background: #f5f5f5;
}

.uBmamJ5 {
  display: flex;
  align-items: center;
  height: 100%;
  height: 100px;
  box-sizing: border-box;
  color: rgb(255, 255, 255);
}

.addcreat {
  min-width: 1920px;
  padding: 40px 160px;
  text-align: center;
  background-color: #fff;
  height: 100%;
  overflow-y: auto;
}

.addcreat-h1 {
  margin-bottom: 76px;
  font-family: "Arial Bold";
  font-weight: bold;
  font-size: 30px;
  color: #1a2332;
  line-height: 39px;
  text-align: center;
  font-style: normal;
}

.addcreat-h2 {
  font-size: 14px;
  color: #8497ab;
  line-height: 14px;
  text-align: center;
  margin-bottom: 52px;
}

.addcreat-card {
  width: 380px;
  min-width: 380px;
  padding: 30px;
  position: relative;
  background: #f5f5f5;
  border-radius: 24px;
}

.addcreat-card img {
  position: absolute;
  left: 50%;
  top: -2.5%;
  transform: translateX(-50%);
  width: 70px;
  height: 50px;
}

.addcreat_root .addcreat-card:last-child img {
  width: 64px;
  height: 64px;
  top: -4%;
}

.arrcreat-head {
  height: 44px;
  font-family: "Arial Bold";
  font-size: 26px;
  color: #1a2332;
  line-height: 44px;
  text-align: left;
  font-style: normal;
}

.arrcreat-head span {
  font-family: "Arial Bold";
}

.arrcreat-headtwo {
  padding-bottom: 16px;
  text-align: left;
  font-size: 14px;
  font-family: "Arial";
}

.arrcreat-countet {
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid #cccccc;
}

.el-icon-check {
  color: #1290c9;
  font-size: 12px;
}

.arrcreat-li-bottom {
  font-size: 14px;
  color: #1290c9;
  line-height: 18px;
  text-align: left;
  margin-top: 35px;
  text-decoration-line: underline;
}

.arrcreat-li-gouxuan {
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  font-family: "Arial";
  font-size: 14px;
  color: #1a2332;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.arrcreat-li-gouxuan.flex_box {
  margin-bottom: 14px;
}

.arrcreat-active {
  background: #1a2332;
  border-radius: 21px;
}

.arrcreat-active .arrcreat-head,
.arrcreat-active .arrcreat-headtwo,
.arrcreat-active .arrcreat-countet .arrcreat-li-gouxuan,
.arrcreat-active .arrcreat-countet .arrcreat-li-bottom,
.arrcreat-active .arrcreat-bottom-money {
  color: #fff;
}

.arrcreat-bottom-money {
  font-family: "Arial Bold";
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 40px;
  color: #5d6676;
  line-height: 40px;
  text-align: left;
  font-style: normal;
}

.arrcreat-bottom {
  text-align: left;
  margin-top: 10px;
  line-height: 52px;
  display: flex;
  align-items: flex-end;
}

.arrcreat-bottomi {
  margin-left: 6px;
  font-family: "Arial";
  font-size: 14px;
  color: #1a2332;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}

.black_button {
  height: 40px;
  background: #1290c9;
  border-radius: 10px;
  width: 100%;
  font-family: "Arial";
  font-size: 18px;
  color: #ffffff;
  line-height: 16px;
  text-align: center;
  font-style: normal;
}

.black_buttonhui {
  height: 40px;
  background: #cccccc;
  border-radius: 10px;
  width: 100%;
  font-family: "Arial";
  font-size: 18px;
  color: #ffffff;
  line-height: 16px;
  text-align: center;
  font-style: normal;
}

.arrcreat-active .black_button {
  background: #d9a677;
}

.arrcreat-bottom-last {
  margin-top: 14px;
  border-radius: 10px;
}

/deep/ .el-input__inner:focus,
/deep/ .el-input__inner {
  border-color: #cccccc !important;
  height: 40px;
  font-family: "Arial";
  font-size: 16px;
  color: #1a2332;
  background: #ffffff;
  border-radius: 10px;
}

.arrcreat-bottom-last /deep/ .el-input__inner {
  font-size: 16px;
}

/deep/ .el-form-item {
  display: flex;
  margin-bottom: 20px;
}

/deep/ .el-form--label-left .el-form-item__label {
  min-width: 192px;
  height: 50px;
  margin-right: 10px;
  margin-bottom: 0;
  font-size: 20px;
  color: #1a2332;
  line-height: 50px;
  text-align: left;
  font-style: normal;
}

.flex_input /deep/ .el-form-item__content {
  width: 100%;
}

/deep/ .el-select {
  width: 100%;
}

.pay_title {
  margin-bottom: 20px;
  font-family: "Arial Bold";
  font-size: 26px !important;
  color: #1a2332;
  line-height: 28px !important;
  text-align: center;
  font-style: normal;
}

.total_txt {
  height: 50px;
  margin-top: 30px;
  padding-left: 12px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.total_txt span {
  font-family: "Arial Bold";
}

.tip_txt {
  padding-left: 12px;
  font-size: 18px;
  color: #1a2332;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}

.btn_box {
  margin-top: 30px;
  width: 100%;
  text-align: center;
}

.SelectNumm {
  font-family: "Arial Bold";
  font-size: 28px;
  color: #1a2332;
  line-height: 30px;
  text-align: left;
  font-style: normal;
}

.each {
  height: 20px;
  margin-right: 10px;
  font-family: "Arial";
  font-size: 16px;
  color: #666666;
  line-height: 16px;
  text-align: right;
  font-style: normal;
}

.active {
  background-color: #1a2332;
}

.active .arrcreat-head,
.active .arrcreat-headtwo,
.active .arrcreat-li-gouxuan,
.active .arrcreat-bottom-money {
  color: #ffffff;
}

.arrcreat-li-gouxuan span {
  font-family: "Arial";
}

.active .arrcreat-li-bottom {
  color: #d9a677;
  font-family: "Arial";
}

.active .black_buttonhui {
  background: #d9a677;
  color: #1a2332;
  font-family: "Arial";
}

.active .black_button {
  background: #d9a677;
  color: #1a2332;
  font-family: "Arial";
}

#c2f92a {
  height: 634px;
  position: fixed;
  top: 0rem;
  right: 0rem;
}

.arrcreat-bottomp {
  margin-top: 10px;
  margin-bottom: 16px;
  font-weight: 400;
  font-family: "Arial";
  font-size: 14px;
  color: #1a2332;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.arrcreat-bottomp_last {
  margin-top: 7px;
}

.vipqiehuan {
  height: 38px;
  background: #ededed;
  border-radius: 20px;
  margin-bottom: 16px;
}

.ipqiehuan_button {
  height: 36px;
  font-family: "Arial";
  width: 50%;
  border-radius: 18px;
  background-color: transparent;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 18px;
  text-align: center;
  font-style: normal;
}

.ipqiehuan_buttonactive {
  color: #ffffff;
  background: linear-gradient(180deg, #5c6576 0%, #959dae 100%);
}

.ipqiehuan_buttonactiveyellow {
  color: #ffffff;
  background: linear-gradient(180deg, #e58c1d 0%, #fadb7d 100%);
}

.Contactus {
  font-family: "Arial Bold";
  font-size: 40px;
  color: #1290c9;
  line-height: 40px;
  text-align: left;
  font-style: normal;
}

.Creditpoints {
  width: 96px;
  font-family: "Arial" !important;
  font-size: 18px;
  color: #1a2332;
  line-height: 22px;
  text-align: right;
  font-style: normal;
}

::v-deep .el-dialog__body,
::v-deep .puy_dialog {
  width: 800px;
  height: auto;
}

::v-deep .el-dialog__body {
  padding: 30px;
}

::v-deep .el-dialog__body .el-form-item__content {
  flex: 1;
}

::v-deep .el-dialog__body .el-input__inner {
  height: 50px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-size: 16px;
  line-height: 30px;
  text-align: left;
  font-style: normal;
}

::v-deep .el-dialog__body .pay_expDate .el-input__inner {
  height: 50px;
}

::v-deep .el-dialog__body .pay_expDate .el-form-item:first-child {
  margin-right: 30px;
}

.title_tol {
  margin-right: 20px;
  font-family: "Arial Bold";
  font-size: 20px;
  color: #1a2332;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}

.dollar_sign {
  margin-right: 5px;
}

.btn_box_item {
  width: 210px;
  height: 60px;
  border-radius: 10px;
  font-family: "Arial Bold";
  font-size: 20px;
  color: #ffffff;
  line-height: 26px;
  text-align: center;
  font-style: normal;
}

.flex_between_box,
.flex_center_between_box {
  justify-content: center;
  gap: 20px;
}

@media screen and (max-width: 1920px) {
  .uBmamJ5 {
    height: 80px;
  }

  .addcreat {
    min-width: 1536px;
    padding: 26px 128px;
  }

  .addcreat-h1 {
    margin-bottom: 60px;
    font-size: 24px;
    line-height: 32px;
  }

  .addcreat-h2 {
    font-size: 12px;
    line-height: 12px;
    margin-bottom: 42px;
  }

  .addcreat-card {
    width: 340px;
    min-width: 340px;
    padding: 24px;
    border-radius: 20px;
  }

  .addcreat-card img {
    width: 56px;
    height: 40px;
  }

  .addcreat_root .addcreat-card:last-child img {
    width: 52px;
    height: 52px;
  }

  .arrcreat-head {
    height: 36px;
    font-size: 22px;
    line-height: 36px;
  }

  .arrcreat-headtwo {
    padding-bottom: 14px;
    font-size: 12px;
  }

  .arrcreat-countet {
    padding-top: 16px;
    margin-top: 16px;
  }

  .el-icon-check {
    font-size: 10px;
  }

  .arrcreat-li-bottom {
    font-size: 12px;
    line-height: 14px;
    margin-top: 28px;
  }

  .arrcreat-li-gouxuan {
    font-family: "Arial Bold";
    margin-bottom: 12px;
    font-size: 16px;
    line-height: 20px;
  }

  .arrcreat-li-gouxuan.flex_box {
    margin-bottom: 11px;
  }

  .arrcreat-active {
    border-radius: 18px;
  }

  .arrcreat-bottom-money {
    font-size: 32px;
    line-height: 32px;
  }

  .arrcreat-bottom {
    margin-top: 8px;
    line-height: 42px;
  }

  .arrcreat-bottomi {
    margin-left: 5px;
    font-size: 16px;
    line-height: 20px;
  }

  .black_button {
    height: 32px;
    border-radius: 8px;
    font-size: 16px;
    line-height: 16px;
  }

  .black_buttonhui {
    height: 32px;
    border-radius: 8px;
    font-size: 16px;
    line-height: 16px;
  }

  .arrcreat-bottom-last {
    margin-top: 12px;
    border-radius: 8px;
  }

  ::v-deep .el-input__inner:focus,
  ::v-deep .el-input__inner {
    height: 32px;
    font-size: 14px;
    border-radius: 8px;
  }

  .arrcreat-bottom-last /deep/ .el-input__inner {
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 16px;
  }

  ::v-deep .el-form--label-left .el-form-item__label {
    min-width: 154px;
    height: 40px;
    margin-right: 8px;
    font-size: 16px;
    line-height: 40px;
  }

  .pay_title {
    margin-bottom: 16px;
    font-size: 22px !important;
    line-height: 24px !important;
  }

  .total_txt {
    height: 40px;
    margin-top: 24px;
    padding-left: 10px;
    margin-bottom: 8px;
  }

  .tip_txt {
    padding-left: 10px;
    font-size: 16px;
    line-height: 20px;
  }

  .btn_box {
    margin-top: 24px;
  }

  .SelectNumm {
    font-size: 24px;
    line-height: 24px;
  }

  .each {
    height: 16px;
    margin-right: 8px;
    font-size: 14px;
    line-height: 14px;
  }

  #c2f92a {
    height: 510px;
  }

  .arrcreat-bottomp {
    margin-top: 22px;
    margin-bottom: 26px;
    font-size: 16px;
    line-height: 20px;
  }

  .addcreat-card:last-child .arrcreat-bottomp {
    margin-top: 8px;
    margin-bottom: 14px;
  }

  .arrcreat-bottomp_last {
    margin-top: 6px;
  }

  .vipqiehuan {
    height: 34px;
    border-radius: 16px;
    margin-bottom: 24px;
  }

  .ipqiehuan_button {
    height: 34px;
    border-radius: 16px;
    font-size: 16px;
    line-height: 20px;
  }

  .Contactus {
    font-size: 32px;
    line-height: 32px;
  }

  .Creditpoints {
    width: 80px;
    font-size: 16px;
    line-height: 18px;
  }

  ::v-deep .el-dialog__body,
  ::v-deep .puy_dialog {
    width: 640px;
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
  }

  ::v-deep .el-dialog__body .el-input__inner {
    height: 40px;
    border-radius: 8px;
    font-size: 14px;
    line-height: 24px;
  }

  ::v-deep .el-dialog__body .pay_expDate .el-input__inner {
    height: 40px;
  }

  ::v-deep .el-dialog__body .pay_expDate .el-form-item:first-child {
    margin-right: 24px;
  }

  .title_tol {
    margin-right: 16px;
    font-size: 16px;
    line-height: 20px;
  }

  .dollar_sign {
    margin-right: 4px;
  }

  .btn_box_item {
    width: 170px;
    height: 50px;
    border-radius: 8px;
    font-size: 16px;
    line-height: 20px;
  }
}

@media screen and (max-width: 1439px) {
  .uBmamJ5 {
    height: 68px;
  }

  .addcreat {
    min-width: 1280px;
    padding: 26px 106px;
  }

  .addcreat-h1 {
    margin-bottom: 50px;
    font-size: 20px;
    line-height: 26px;
  }

  .addcreat-h2 {
    font-size: 12px;
    line-height: 12px;
    margin-bottom: 34px;
  }

  .addcreat-card {
    width: 290px;
    min-width: 290px;
    padding: 20px;
    border-radius: 16px;
  }

  .addcreat-card img {
    width: 46px;
    height: 32px;
  }

  .addcreat_root .addcreat-card:last-child img {
    width: 42px;
    height: 42px;
  }

  .arrcreat-head {
    height: 30px;
    font-size: 16px;
    line-height: 30px;
  }

  .arrcreat-headtwo {
    padding-bottom: 10px;
    font-size: 12px;
  }

  .arrcreat-countet {
    padding-top: 12px;
    margin-top: 12px;
  }

  .el-icon-check {
    font-size: 8px;
  }

  .arrcreat-li-bottom {
    font-size: 12px;
    line-height: 12px;
    margin-top: 24px;
  }

  .arrcreat-li-gouxuan {
    margin-bottom: 24px;
    font-size: 14px;
    line-height: 16px;
  }

  .arrcreat-li-gouxuan.flex_box {
    margin-bottom: 16px;
  }

  .arrcreat-active {
    border-radius: 14px;
  }

  .arrcreat-bottom-money {
    font-size: 26px;
    line-height: 26px;
  }

  .arrcreat-bottom {
    margin-top: 6px;
    line-height: 34px;
  }

  .arrcreat-bottomi {
    margin-left: 4px;
    font-size: 14px;
    line-height: 18px;
  }

  .black_button {
    height: 26px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 14px;
  }

  .black_buttonhui {
    height: 26px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 14px;
  }

  .arrcreat-bottom-last {
    margin-top: 9px;
    border-radius: 6px;
  }

  ::v-deep .el-input__inner:focus,
  ::v-deep .el-input__inner {
    height: 26px;
    font-size: 12px;
    border-radius: 6px;
  }

  .arrcreat-bottom-last /deep/ .el-input__inner {
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 12px;
  }

  ::v-deep .el-form--label-left .el-form-item__label {
    min-width: 136px;
    height: 32px;
    margin-right: 6px;
    font-size: 14px;
    line-height: 32px;
  }

  .pay_title {
    margin-bottom: 12px;
    font-size: 16px !important;
    line-height: 18px !important;
  }

  .total_txt {
    height: 32px;
    margin-top: 20px;
    padding-left: 8px;
    margin-bottom: 6px;
  }

  .tip_txt {
    padding-left: 8px;
    font-size: 14px;
    line-height: 16px;
  }

  .btn_box {
    margin-top: 20px;
  }

  .SelectNumm {
    font-size: 20px;
    line-height: 20px;
  }

  .each {
    height: 12px;
    margin-right: 6px;
    font-size: 14px;
    line-height: 14px;
  }

  #c2f92a {
    height: 426px;
  }

  .arrcreat-bottomp {
    min-height: 24px;
    margin-top: 18px;
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 14px;
  }

  .addcreat-card:last-child .arrcreat-bottomp {
    margin-top: 6px;
    margin-bottom: 10px;
  }

  .arrcreat-bottomp_last {
    margin-top: 5px;
  }

  .vipqiehuan {
    height: 24px;
    border-radius: 12px;
    margin-bottom: 11px;
  }

  .ipqiehuan_button {
    height: 26px;
    border-radius: 12px;
    font-size: 14px;
    line-height: 14px;
  }

  .Contactus {
    font-size: 26px;
    line-height: 26px;
  }

  .Creditpoints {
    width: 66px;
    font-size: 14px;
    line-height: 14px;
  }

  ::v-deep .el-dialog__body,
  ::v-deep .puy_dialog {
    width: 536px;
  }

  ::v-deep .el-dialog__body {
    padding: 20px;
  }

  ::v-deep .el-dialog__body .el-input__inner {
    height: 32px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 20px;
  }

  ::v-deep .el-dialog__body .pay_expDate .el-input__inner {
    height: 32px;
  }

  ::v-deep .el-dialog__body .pay_expDate .el-form-item:first-child {
    margin-right: 20px;
  }

  .title_tol {
    margin-right: 12px;
    font-size: 14px;
    line-height: 16px;
  }

  .dollar_sign {
    margin-right: 3px;
  }

  .btn_box_item {
    width: 140px;
    height: 40px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 16px;
  }
}
</style>
